@if(type == 'footer_one'){
  <app-footer-one [data]="this.themeOptions" [logo]="logo"></app-footer-one>
}@else if(type == 'footer_two'){
  <app-footer-two [data]="this.themeOptions" [logo]="logo"></app-footer-two>
}@else if(type == 'footer_three'){
  <app-footer-three [data]="this.themeOptions" [logo]="logo"></app-footer-three>
}@else if(type == 'footer_four'){
  <app-footer-four [data]="this.themeOptions" [logo]="logo"></app-footer-four>
}
